import { RouteObject } from 'react-router-dom'

import BasicLayout from '@/presentation/components/ui/layout/basic-layout'
import AuthLayout from '@/presentation/components/ui/layout/auth-layout'

import * as Pages from './pages'

import { PathConstants } from './paths'
import { RecaptchaProvider } from '@/presentation/contexts/recaptcha/recaptcha-provider'

// ============================================
// UNAUTHENTICATED ROUTES BUILDER
// ============================================

/**
 * All unauthenticated (public) routes
 * These routes are accessible without authentication
 *
 * @returns Array of RouteObjects for React Router
 */

export const UnauthenticatedRoutes = (): RouteObject[] => {
  const routes = [
    {
      element: <AuthLayout />,
      children: [
        {
          path: PathConstants.Routes.LOGIN.value,
          element: (
            <RecaptchaProvider>
              <Pages.LoginPage />
            </RecaptchaProvider>
          )
        },
        {
          path: PathConstants.Routes.FORGOT_PASSWORD.value,
          element: (
            <RecaptchaProvider>
              <Pages.ForgotPasswordPage />
            </RecaptchaProvider>
          )
        },
        {
          path: PathConstants.Routes.RESET_PASSWORD.value,
          element: (
            <RecaptchaProvider>
              <Pages.ResetPasswordPage />
            </RecaptchaProvider>
          )
        },
        {
          path: PathConstants.Routes.RESEND_ACCESS.value,
          element: (
            <RecaptchaProvider>
              <Pages.ResendAccessPage />
            </RecaptchaProvider>
          )
        },
        {
          path: PathConstants.Routes.LOGIN_FIRST_ACCESS.value,
          element: (
            <RecaptchaProvider>
              <Pages.LoginFirstAccessPage />
            </RecaptchaProvider>
          )
        }
      ]
    },
    {
      element: <BasicLayout footerVariant="compact" />,
      children: [
        {
          path: PathConstants.Routes.FIRST_ACCESS.value,
          element: <Pages.FirstAccessPage />
        },
        {
          path: PathConstants.Routes.FIRST_ACCESS_CPF.value,
          element: (
            <RecaptchaProvider>
              <Pages.FirstAccessCpfPage />
            </RecaptchaProvider>
          )
        }
      ]
    },
    {
      path: PathConstants.Routes.CB_UNICO_SUCCESS.value,
      element: <Pages.CbUnicoSuccessPage />
    },
    {
      path: PathConstants.Routes.SKILL_EXPLORER_CATALOG.value,
      element: <Pages.SkillExplorerCatalogPage />
    }
  ]

  return [...routes]
}
